import type { ApplicationEdition } from '@atlassian/invite-people/types';

export const mapOfferingNameToEdition = (
	offeringName: string | null | undefined,
): ApplicationEdition => {
	const lowerName = offeringName?.toLocaleLowerCase() ?? '';
	if (lowerName.includes('free')) {
		return 'FREE_EDITION';
	}
	if (lowerName.includes('standard')) {
		return 'STANDARD_EDITION';
	}
	if (lowerName.includes('premium') || lowerName.includes('enterprise')) {
		return 'PREMIUM_EDITION';
	}
	return 'UNLICENSED';
};
